import {SetFieldFn} from "../../data";
import {Box} from "@mui/material";
import SearchField from "../../SearchField";
import {useUpdateSearchParam} from "../../../hooks/useUpdateSearchParams";
import {kontakteStyles} from "../../../styles/kontakte/kontakte.styles";

export type KontakteViewFilter = {
    search?: string;
    filtered?: string;
}

interface FilterTableKontakteViewProps {
    search?: string;
    setField: SetFieldFn<KontakteViewFilter>;
}

export default function FilterTableKontakteView({ search, setField }: FilterTableKontakteViewProps) {
    const updateSearchParam = useUpdateSearchParam();

    const handleSearchChange = (searchString: string) => {
        setField("search", searchString);
        updateSearchParam("search", searchString);
    };

    return (
        <Box sx={kontakteStyles.filterTableKontakteView.box}>
            <SearchField
                value={search ?? ""}
                onChange={(searchString: string) => handleSearchChange(searchString)}
            />
        </Box>
    );
}